/* eslint-disable no-else-return */
import { useEffect, useRef } from "react"

export const useInterval = (callback: () => void, delay: number | null) => {

  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (!delay) return
    const id = setInterval(() => savedCallback.current(), delay)
    return () => clearInterval(id)
  }, [delay])
}
